import { VAlert } from 'vuetify-wcag/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c(VAlert,{attrs:{"type":_vm.type,"color":_vm.$helpers.color.darkModeColor(_vm.color, _vm.strength),"text":"","transition":"scale-transition","origin":"center center","dense":_vm.dense}},[_vm._v(_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }